import { FC } from 'react';

import { MarketplaceChannel } from '~/types/marketplace';

import { NeedHelp } from '../need-help';

import { PromoBanner } from './promotion-banner';

type InterstitialBannerProps = {
  channel: MarketplaceChannel | null;
  code?: string;
};

const InterstitialBanner: FC<InterstitialBannerProps> = ({ channel, code }) => {
  if (code) {
    return <PromoBanner code={code} channel={channel} />;
  }

  return <NeedHelp />;
};

export { InterstitialBanner };
